import React from "react";
import style from "../Content.module.css";


import smartphone from '../../../assets/smartphone.png';
import excel from '../../../assets/excel.png'
import excelAnimation from '../../../assets/excel-animation.gif'
import messengerAnimation from '../../../assets/messenger-animation.gif'
import scissors from '../../../assets/scissors.png'
import sort from '../../../assets/sort.png'
import video from '../../../assets/video.png'
import task from '../../../assets/task.png'
import clientPanel from '../../../assets/client-panel.gif'
import contacts from '../../../assets/contacts.png'
import adm from '../../../assets/adm.gif'
import crm from '../../../assets/crm.png'
import drag from '../../../assets/drag.png'

import {Project} from './Project';


export const Projects = () => {

    return (
        <div className={style.mainWrapper}>


            <Project
              projectName='CLIENT PANEL'
              imgProjectRef={contacts}
              repositories='github.com/arturexpone/client-panel'
              refRepositories='https://github.com/arturexpone/client-panel'
              refDeploy='https://client-panel.netlify.app'
              refName='client-panel.netlify.app'
              dataOnLogin={['test@ya.ru', '123456']}
              gif={clientPanel}
              purposeProject={(
                <p>
                Сделать приложение, приближенное к реально используемым сервисам,
                  поработать с firebase, укрепить знания в React & Redux.
                </p>
              )}
              readyFunctionally={
                  [
                  'Регистрация/логинизация пользователей',
                  'Добавление новых пользователей',
                  'Поверхностное (быстрое) и максимально подробное редактирование информации о контакте',
                  'Подсчет общей суммы наличности клиентов',
                  'Выход из приложения и редирект при отсутствии auth token',
                  `Выключение регистрации (вкладка 'Settings')`,
                  `Отключение возможности быстрого редактирования (вкладка 'Settings')`,
                  `Отключение возможности добавлять баланс (вкладка 'Settings')`,
                  'Спиннер, необходимый для UX',
                  'Валидатор для входа/регистрации',
                  ]}
              usedTechnologies=' React, Redux, hooks, bootstrap, classnames, suspense, Firebase ( && Redux ).'
            />

            <Project
              projectName='ADM.BY'
              imgProjectRef={crm}
              refDeploy='http://adm.by/'
              refName='adm.by'
              gif={adm}
              purposeProject={(
                  <p>
                  Проект является отдельным (от основного) порталом, на котором размещены курсы (уроки + тестирование),
                  по обучению работе в amoCRM, включая тонкости и общие концепции, которые необходимо понимать при работе в любой CRM.
                  UI и logic layer собран мной из готовых решений с правками, необходимыми в
                  рамках этого проекта. <br/>
                  Также, весь курс обучения подготовлен мной (уроки разделены по уровню сложности и
                  необходимости обучения в рамках роли обучающегося сотрудника [Менеджер, Руководитель отдела, Директор]).
                  <br/>
                  P.S не весь контент находящийся на данном портале вне рамок закрытого курса, был написан мной.
                  <br/>
                  </p>
                  )
              }
              readyFunctionally={
                  [
                      'Закрытие доступа к обучению для клиентов, не оплативших доступ и через месяц после выполнения первого теста',
                      'Открытый вход для оплативших пользователей через bepaid',
                      'Удобное меню, адаптированное под обучение',
                      'Тестирование после прохождения каждого блока курса',
                      `Запись информации о прохождении курса каждым клиентом в CRM, автоматическая
                       отправка писем на email клиенту с общей информацией о прохождении тестирования`,
                      `Закрытие доступа к обучению после единократного прохождения курса`,
                      `Внутри курса закрыт доступ к dev tools и другим возможностям кражи контента`,
                  ]}
              usedTechnologies=' JavaScript, PHP, WP.'
            />

            <Project
              projectName='MESSENGER'
              imgProjectRef={smartphone}
              repositories='github.com/arturexpone/messenger'
              refRepositories='https://github.com/arturexpone/messenger'
              refDeploy='http://32426dfa99a7.ngrok.io/'
              refName='messenger.app'
              dataOnLogin={['любой', 'любой']}
              gif={messengerAnimation}
              purposeProject={(
                <p>
                    Потренироваться работать с React-Redux, научиться создавать не сложный сервер и работать
                    с вебсокетами.
                </p>
              )}
              readyFunctionally={
                  [
                      'Простая логинизация, с возможностью войти в ранее созданную комнату или создать новую',
                      'В комнате может находится неограниченное количество людей',
                      'Вывод списка всех комнат с возможностью переключение между ними',
                      'Вывод списка всех пользователей, принимающих участие в диалоге (в рамках этой комнаты)',
                      'Информация о кол-во сообщений в рамках комнаты',
                      `Редирект при попытке входа незалогиненного пользователя`,
                      `Сохранение данных о пользователе в localStorage`,
                      `Все данные хранятся в базе данных (MongoDB)`,
                  ]}
              usedTechnologies=' React-Redux, socket.io, node.js, MongoDB.'
            />

            <Project
              projectName='EXCEL'
              imgProjectRef={excel}
              repositories='github.com/arturexpone/excel'
              refRepositories='https://github.com/arturexpone/excel'
              refDeploy='https://arturexpone-excel.netlify.app/'
              refName='arturexpone-excel.netlify.app'
              gif={excelAnimation}
              purposeProject={(
                <p>
                    В полной мере ипользовать возможности JS ES6+, поработать с webpack
                    и browser API, улучшить понимание работы с наследованием.
                </p>
              )}
              readyFunctionally={
                  [
                      'Выделение диапазона ячеек с помощью удержания клавиши shift',
                      'Переход по ячейкам клавишами(Arrows, Tab, Enter)',
                      'Информация введенная в поле функции дублируется в активное поле',
                      'Работают простейшие формулы (вычитание, сложение, деление, умножение. Запись производится через символ "=")',
                      'Изменение размера колонок и ячеек',
                      `Удаление, изменение названия таблицы`,
                      `Изменение формата текста и его расположения внутри ячейки(работает для всех одновременно выделенных ячеек)`,
                      `Сохранение таблиц в local storage`,
                  ]}
              usedTechnologies=' JavaScript, Webpack, SASS.'
            />

            <Project
              projectName='CONTACT MANAGER'
              imgProjectRef={task}
              repositories='github.com/arturexpone/contact-manager'
              refRepositories='https://github.com/arturexpone/contact-manager'
              refDeploy='https://arturexpone-cm.netlify.app/'
              refName='arturexpone-cm.netlify.app'
              isFrame='https://arturexpone-cm.netlify.app/'
              purposeProject={(
                <p>
                    Программа для менеджмента контактов.
                </p>
              )}
              readyFunctionally={
                  [
                      'Получение контактов с сервера',
                      'Редактирование, добавление, удаление контактов',
                      'Роутинг и редирект',
                      'Валидация формы добавления контакта',
                  ]}
              usedTechnologies=' React, Redux (react-redux), hooks, BrowserRouter, axios, redux-thunk, bootstrap.'
            />

          <Project
            projectName='RPS GAME'
            imgProjectRef={scissors}
            repositories='github.com/arturexpone/rock-paper-scissors'
            refRepositories='https://github.com/arturexpone/rock-paper-scissors'
            refDeploy='https://arturexpone-rpsgame.netlify.app/'
            refName='arturexpone-rpsgame.netlify.app'
            isFrame='https://arturexpone-rpsgame.netlify.app/'
            purposeProject={(
              <p>
                Игра камень-ножницы-бумага. Реализована на Native JS, без использования библиотек.
              </p>
            )}
            usedTechnologies=' JavaScript, HTML, CSS.'
          />

          <Project
            projectName='SORT DATA OF USERS'
            imgProjectRef={sort}
            repositories='github.com/arturexpone/sorting-data-of-random-users'
            refRepositories='https://github.com/arturexpone/sorting-data-of-random-users'
            refDeploy='https://arturexpone-sort.netlify.app/'
            refName='arturexpone-sort.netlify.app'
            isFrame='https://arturexpone-sort.netlify.app/'
            purposeProject={(
              <p>
                Реализована загрузка данных пользователей с сервера и сортировка с использованием различных методов.
              </p>
            )}
            usedTechnologies=' JavaScript, HTML, CSS.'
          />

          <Project
            projectName='SEAT RESERVATION'
            imgProjectRef={video}
            repositories='github.com/arturexpone/seat-reservation'
            refRepositories='https://github.com/arturexpone/seat-reservation'
            refDeploy='https://arturexpone-sr.netlify.app/'
            refName='arturexpone-sr.netlify.app'
            isFrame='https://arturexpone-sr.netlify.app/'
            purposeProject={(
              <p>
                Реализовано бронирование билетов в кинотеатр, с подсчетом суммы билетов в зависимости от выбранного фильма.
                Временная бронь сохраняется в local storage.
              </p>
            )}
            usedTechnologies=' JavaScript, HTML, CSS.'
          />

          <Project
            projectName='DRAG & DROP'
            imgProjectRef={drag}
            repositories='github.com/arturexpone/drag-drop-list'
            refRepositories='https://github.com/arturexpone/drag-drop-list'
            refDeploy='https://arturexpone-dd.netlify.app/'
            refName='arturexpone-dd.netlify.app'
            isFrame='https://arturexpone-dd.netlify.app/'
            purposeProject={(
              <p>
                Список с возможностью drag & drop редактирования. Реализован на Native JS (browser API), без использования библиотек.
              </p>
            )}
            usedTechnologies=' JavaScript, HTML, CSS.'
          />

        </div>

    )
}